<template>
  <v-text-field
    dense
    outlined
    type="number"
    :disabled="disabled"
    :error-messages="errorMessages"
    :step="step"
    v-model="model"
    @blur="v.$touch()"
    @input="v.$touch()"
  >
    <template #label>
      <span v-text="label" />
    </template>
    <template v-if="max" #append>
      <v-btn text @click="setMax">
        <span class="info--text">max</span>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseNumberField',
  emits: ['input'],
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    v: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: [Number, String],
      required: false,
    },
    step: {
      type: String,
      default: '0.1',
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    errorMessages() {
      const errors = [];
      if (!this.v || !this.v.$dirty) {
        return errors;
      }
      if ('required' in this.v && !this.v.required) {
        errors.push('This field is required');
        return errors;
      }
      if ('maxValue' in this.v && !this.v.maxValue) {
        errors.push('The value is too high');
        return errors;
      }
      if ('minValue' in this.v && !this.v.minValue) {
        errors.push('The value is too low');
        return errors;
      }
      if ('isPositiveAmount' in this.v && !this.v.isPositiveAmount) {
        errors.push('The value must be greater than 0');
        return errors;
      }
      return errors;
    },
  },
  methods: {
    setMax() {
      this.model = this.max;
    },
  },
};
</script>
